var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlockedIcon = function SvgBlockedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8730_15137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49991 12.5L12.4999 7.5",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93417 16.7675L3.23167 14.065C2.76333 13.5967 2.5 12.9608 2.5 12.2975V7.7025C2.5 7.03917 2.76333 6.40333 3.2325 5.935L5.935 3.2325C6.40333 2.76333 7.03917 2.5 7.7025 2.5H12.2975C12.9608 2.5 13.5967 2.76333 14.065 3.2325L16.7683 5.93583C17.2367 6.40417 17.5 7.04 17.5 7.70333V12.2975C17.5 12.9608 17.2367 13.5958 16.7683 14.065L14.0658 16.7683C13.5967 17.2367 12.9608 17.5 12.2975 17.5H7.7025C7.03917 17.5 6.40333 17.2367 5.93417 16.7675Z",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8730_15137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgBlockedIcon as ReactComponent };
export default __webpack_public_path__ + "blocked-icon.svg";